import { type FC } from 'react';
import { Card, type CardProps } from '@material-ui/core';
import cx from 'classnames';

import {
  GENERATION_TOOL_CARD_IMAGE_SIZE,
  GenerationToolCardImage,
} from 'src/components/GenerationToolCardImage';
// @ts-expect-error - TruncatedTypography is not typed yet
import { TruncatedTypography, TYPOGRAPHY_VARIANT } from 'src/components/TruncatedTypography';
import { type GenerationTool } from 'src/data/generationTool';
import type { ProjectType } from 'src/data/project';
import type { MultiPromptTemplate, SubTemplate } from 'src/data/template';

import styles from './styles.module.scss';

interface CardMediumProps {
  className?: string;
  projectType: ProjectType;
  generationTool: GenerationTool;
  customToolData: MultiPromptTemplate;
  subTemplateData: SubTemplate;
  title: string;
  copy: string;
  selected?: boolean;
  onClick: CardProps['onClick'];
  disabled?: boolean;
}

export const CardMedium: FC<CardMediumProps> = ({
  className,
  projectType,
  generationTool,
  customToolData,
  title,
  copy,
  selected,
  onClick,
  disabled,
}) => {
  return (
    <Card
      className={cx(styles.root, className, {
        [styles.selected]: selected,
        [styles.disabled]: disabled,
      })}
      onClick={disabled ? undefined : onClick}
      data-testid={`templateButton_${generationTool}`}
    >
      <GenerationToolCardImage
        className={styles.icon}
        projectType={projectType}
        tool={generationTool}
        svgStringImage={customToolData?.smallImage}
        size={GENERATION_TOOL_CARD_IMAGE_SIZE.medium}
      />

      <div className={styles.content}>
        <TruncatedTypography
          className={styles.title}
          variant={TYPOGRAPHY_VARIANT.medium14}
        >
          {title}
        </TruncatedTypography>

        <TruncatedTypography
          className={styles.copy}
          variant={TYPOGRAPHY_VARIANT.paragraph10}
          maxLines={3}
          multiline
        >
          {copy}
        </TruncatedTypography>
      </div>
    </Card>
  );
};
